import { ranking } from "@/mocks/works";
import SectionHeading from "./SectionHeading";

const trendIcon: Record<string, string> = {
  up: "ri-arrow-up-line text-primary-500",
  down: "ri-arrow-down-line text-secondary-500",
  keep: "ri-subtract-line text-foreground-400",
};

export default function Ranking() {
  return (
    <section id="ranking" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-6 lg:flex-row lg:items-end">
          <SectionHeading
            align="left"
            eyebrow="人气排行榜"
            title="本期人气口碑 TOP 8"
            desc="综合同好评分与讨论热度动态排序，高分作品经得起反复回味，帮你优先锁定真正值得看的佳作。"
          />
          <a
            href="#roundups"
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-6 py-2.5 text-sm font-semibold text-foreground-900 hover:bg-accent-600 transition-colors"
          >
            查看年度榜单
            <i className="ri-bar-chart-line text-base" aria-hidden="true"></i>
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 lg:grid-cols-2">
          {ranking.map((item) => (
            <article
              key={item.rank}
              className="group flex items-center gap-4 rounded-2xl bg-background-50 p-4 ring-1 ring-background-200/80 transition-transform duration-300 hover:-translate-y-0.5 md:p-5"
            >
              <div
                className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl font-heading text-xl font-black md:h-14 md:w-14 ${
                  item.rank <= 3
                    ? "bg-primary-500 text-background-50"
                    : "bg-secondary-100 text-secondary-800"
                }`}
              >
                {item.rank}
              </div>

              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <h3 className="truncate font-heading text-base font-bold text-foreground-900 md:text-lg">
                    《{item.title}》
                  </h3>
                  <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-medium text-secondary-800 whitespace-nowrap">
                    {item.year}
                  </span>
                </div>
                <p className="mt-1 truncate text-xs text-foreground-600 md:text-sm">{item.genre}</p>
              </div>

              <div className="flex shrink-0 flex-col items-end gap-1">
                <span className="flex items-center gap-1 font-heading text-lg font-black text-primary-600 md:text-xl">
                  {item.score.toFixed(1)}
                  <i className={trendIcon[item.trend]} aria-hidden="true"></i>
                </span>
                <span className="text-xs text-foreground-500">同好评分</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}